import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const IBAN_LENGTH_BY_COUNTRY: Record<string, number> = {
  IT: 27,
  DE: 22,
  FR: 27,
  ES: 24,
  GB: 22,
  AT: 20,
  BE: 16,
  NL: 18,
  PT: 25,
  CH: 21,
  IE: 22,
  LU: 20,
  PL: 28,
  GR: 27,
};

export function normalizeIban(value: string): string {
  return (value || '').replace(/\s+/g, '').toUpperCase();
}

function hasValidChecksum(iban: string): boolean {
  const rearranged = iban.substring(4) + iban.substring(0, 4);
  let remainder = 0;
  for (const char of rearranged) {
    const numeric = /[A-Z]/.test(char) ? String(char.charCodeAt(0) - 55) : char;
    for (const digit of numeric) {
      remainder = (remainder * 10 + Number(digit)) % 97;
    }
  }
  return remainder === 1;
}

/**
 * Stesse regole di App\Rules\ValidIban lato backend (formato, lunghezza per paese, checksum MOD-97),
 * ma con un errore distinto per ogni causa, cosi' il form puo' spiegare all'utente cosa non va.
 */
export function ibanValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }

    const iban = normalizeIban(control.value);

    if (/[^A-Z0-9]/.test(iban)) {
      return { ibanChars: true };
    }

    if (!/^[A-Z]{2}[0-9]{2}/.test(iban)) {
      return { ibanStart: true };
    }

    if (iban.length < 15 || iban.length > 34) {
      return { ibanSize: { actual: iban.length } };
    }

    const country = iban.substring(0, 2);
    const expectedLength = IBAN_LENGTH_BY_COUNTRY[country];
    if (expectedLength !== undefined && iban.length !== expectedLength) {
      return { ibanLength: { country, expected: expectedLength, actual: iban.length } };
    }

    return hasValidChecksum(iban) ? null : { ibanChecksum: true };
  };
}
